import { Fieldset, Group, NumberInput, Stack, Text, Title } from '@mantine/core';
import { ControlledOptionsSwitcher } from '@/app/components/shared/navigation/OptionsSwitcher';
import { SimpleSlider } from '@/app/components/shared/form/slider/SimpleSlider';
import { useFormContext } from '../../contexts/formContext';

const options = [
  {
    label: 'No Smart Target',
    value: 'none',
  },
  {
    label: 'Screen size target',
    value: 'screenSize',
  },
] as const;

const marks = [
  { value: 512, label: '512' },
  { value: 1024, label: '1024' },
  { value: 2048, label: '2048' },
  { value: 4096, label: '4096' },
];

export function TargetsOperation() {
  const form = useFormContext();

  const value = !!form.getValues().targets?.screenspace ? 'screenSize' : 'none';

  const onOptionChanged = (option: (typeof options)[number]['value']) => {
    if (option === 'screenSize') {
      form.setValues({ targets: { screenspace: 1024 } });
    }

    if (option === 'none') {
      form.setValues({ targets: undefined });
    }
  };

  return (
    <Stack align='flex-start'>
      <Title order={5}>Targets</Title>
      <Text c='gray.6'>
        Smart targets do not serve any performance goal directly but rather optimize for a given visual quality metric.
        The result can be limited in terms of maximum face count, texture resolution or mb through the section above.
      </Text>
      <Stack gap='lg'>
        <ControlledOptionsSwitcher
          options={options}
          value={value}
          onChanged={onOptionChanged}
          renderOption={(option) =>
            option == 'screenSize' ? (
              <Stack>
                <Group w={400} justify='space-between'>
                  <Text>Screen Size</Text>
                  <Group gap='xs'>
                    <NumberInput {...form.getInputProps('targets.screenspace')} min={0} /> px
                  </Group>
                  <SimpleSlider
                    min={0}
                    max={4096}
                    marks={marks}
                    w={400}
                    {...form.getInputProps('targets.screenspace')}
                  />
                </Group>
              </Stack>
            ) : null
          }
        />
      </Stack>
    </Stack>
  );
}
